import { useCallback, useMemo, useState } from 'react';

export const useQuickSearch = ({ data = [], key = 'title' }) => {
  const [value, setValue] = useState('');

  const onChangeTitle = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const filteredData = useMemo(() => {
    if (!value) return data;

    return data.filter(i => i[key]?.toLowerCase().includes(value.toLowerCase()));
  }, [data, value, key]);

  return {
    filteredData,
    onChangeTitle,
    value,
  };
};

